<template>
  <div class="tutorial tutorial__overlay" @click="$emit('close')">
    <h2>{{ $t.tutorialTitle }}</h2>

    <div class="tutorial__step tutorial__step-1">
      <!-- Image -->
      <!-- <img
        v-if="isTouchDevice()"
        src="/assets/img/tutorial/touch-pan--mobile.png"
        alt="Pan image mobile"
      />
      <img v-else src="/assets/img/tutorial/touch-pan.png" alt="Pan image" /> -->
      <!-- Text -->
      <p v-if="isTouchDevice()">{{ $t.tutorialDragMobile }}</p>
      <p v-else>{{ $t.tutorialDrag }}</p>
    </div>

    <div class="tutorial__step tutorial__step-2">
      <!-- Image -->
      <!-- <img
        v-if="isTouchDevice()"
        src="/assets/img/tutorial/touch-pan--mobile.png"
        alt="Pan image mobile"
      />
      <img v-else src="/assets/img/tutorial/touch-pan.png" alt="Pan image" /> -->
      <!-- Text -->
      <p v-if="isTouchDevice()">{{ $t.tutorialZoomMobile }}</p>
      <p v-else>{{ $t.tutorialZoom }}</p>
    </div>

    <Button @click.native.prevent="$emit('close')">
      {{ $t.tutorialButton }}
    </Button>
  </div>
</template>

<script>
import { isTouchDevice } from "@/helpers"
import Button from "@/components/Button.vue"

export default {
  name: "TutorialScreen",
  components: {
    Button,
  },
  methods: {
    isTouchDevice: isTouchDevice,
  },
  computed: {
    tour() {
      return this.$store.state.currentTour
    },
  },
  mounted() {
    localStorage.setItem("tutorialShown", true)
  },
}
</script>

<style lang="scss" scoped>
.tutorial {
  z-index: 10000;

  &__overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    background-color: transparent;
    transition: opacity $basic-trans-200;
    background-color: rgba($color-black, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    cursor: pointer;
  }

  * {
    color: $color-white;
  }

  h2 {
    color: $color-white;
    font-weight: 800;
    text-transform: uppercase;
  }

  .tutorial__step {
    display: flex;
    align-items: center;
    text-align: center;
    flex-direction: column;
    grid-gap: 2rem;

    img {
      margin-right: 1.2rem;
    }

    &-1 {
      margin: 5.6rem 0 1.2rem 0;
    }

    &-2 {
      margin: 1.2rem 0 5.6rem 0;
    }
  }

  @include small-up {
    .tutorial__step {
      grid-gap: rs(20);

      img {
        margin-right: rs(12);
      }

      &-1 {
        margin: rs(56) 0 rs(12) 0;
      }

      &-2 {
        margin: rs(12) 0 rs(56) 0;
      }
    }
  }
}
</style>
